import { render, staticRenderFns } from "./OutersQuoteBackground.vue?vue&type=template&id=4d86361d&scoped=true&"
import script from "./OutersQuoteBackground.vue?vue&type=script&lang=js&"
export * from "./OutersQuoteBackground.vue?vue&type=script&lang=js&"
import style0 from "./OutersQuoteBackground.vue?vue&type=style&index=0&id=4d86361d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d86361d",
  null
  
)

export default component.exports